<div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="treatment-xray-data-dialog-main-container">
  <div class="section-header" style="flex-basis: 30px;" data-cy="treatment-xray-data-dialog-section-header">
    <div class="section-header-title" data-cy="treatment-xray-data-dialog-header-title">
      XRay Data
    </div>
    <div style="flex: 1;"></div>
    <!--    <div (click)="onAddFractureClick()" style="flex-basis: fit-content; cursor: pointer;"><span style="position: relative; top: 3px;"><lucide-icon name="plus-circle" [size]="20"></lucide-icon></span></div>-->
  </div>
  @if (isLoading) {
    <app-tdo-progress-spinner style="flex: 1;" data-cy="treatment-xray-data-dialog-progress-spinner"></app-tdo-progress-spinner>
  }
  @if (!isLoading) {
    <div class="section-content" style="flex: 1;" data-cy="treatment-xray-data-dialog-section-content">
      <div style="display: flex; flex-direction: column;" data-cy="treatment-xray-data-dialog-form-container">
        <div class="xray-data-row" data-cy="treatment-xray-data-dialog-date-row">
          <div style="flex-basis: 146px; text-align: right; margin-right: 8px; margin-top: 3px;" data-cy="treatment-xray-data-dialog-date-label">
            Date:
          </div>
          <div style="flex: 3; position: relative;" data-cy="treatment-xray-data-dialog-date-input-container">
            <input style="width: calc(100% - 30px); background-color: white; padding-left: 4px;" autocomplete="off" (focus)="onStartDateFocus($event)" matInput (dateChange)="onStartDateChange($event)" [(ngModel)]="date"
              [matDatepicker]="pickerStart" data-cy="treatment-xray-data-dialog-date-input">
              <mat-datepicker-toggle style="position: absolute; right: 0; top: 50%; transform: translateY(-50%); width: 30px;" matSuffix [for]="pickerStart" data-cy="treatment-xray-data-dialog-date-picker-toggle"></mat-datepicker-toggle>
              <mat-datepicker #pickerStart data-cy="treatment-xray-data-dialog-date-picker"></mat-datepicker>
            </div>
          </div>
          <div class="xray-data-row" data-cy="treatment-xray-data-dialog-number-of-xrays-row">
            <div style="flex-basis: 146px; text-align: right; margin-right: 8px;" data-cy="treatment-xray-data-dialog-number-of-xrays-label">
              Number of XRays:
            </div>
            <div style="flex: 3;" data-cy="treatment-xray-data-dialog-number-of-xrays-input-container">
              <input type="number" [(ngModel)]="numberOfXrays" data-cy="treatment-xray-data-dialog-number-of-xrays-input" />
            </div>
          </div>
          <div class="xray-data-row" data-cy="treatment-xray-data-dialog-voltage-row">
            <div style="flex-basis: 146px; text-align: right; margin-right: 8px;" data-cy="treatment-xray-data-dialog-voltage-label">
              Voltage in kV:
            </div>
            <div style="flex: 3;" data-cy="treatment-xray-data-dialog-voltage-input-container">
              <input [(ngModel)]="voltageInKv" data-cy="treatment-xray-data-dialog-voltage-input" />
            </div>
          </div>
          <div class="xray-data-row" data-cy="treatment-xray-data-dialog-amperage-row">
            <div style="flex-basis: 146px; text-align: right; margin-right: 8px;" data-cy="treatment-xray-data-dialog-amperage-label">
              Amperage in mA:
            </div>
            <div style="flex: 3;" data-cy="treatment-xray-data-dialog-amperage-input-container">
              <input [(ngModel)]="amperageInMa" data-cy="treatment-xray-data-dialog-amperage-input" />
            </div>
          </div>
          <div class="xray-data-row" data-cy="treatment-xray-data-dialog-exposure-time-row">
            <div style="flex-basis: 146px; text-align: right; margin-right: 8px;" data-cy="treatment-xray-data-dialog-exposure-time-label">
              Exposure Time in Seconds:
            </div>
            <div style="flex: 3;" data-cy="treatment-xray-data-dialog-exposure-time-input-container">
              <input [(ngModel)]="exposureTimeInSeconds" data-cy="treatment-xray-data-dialog-exposure-time-input" />
            </div>
          </div>
        </div>
      </div>
    }
    <div class="section-footer" style="flex-basis: 50px; min-height: 50px; padding-top: 6px;" data-cy="treatment-xray-data-dialog-section-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button [disabled]="!isAllFilled()" (click)="onOkClick()" class="tdo-button primary-accent" style="margin-right: 6px;" data-cy="treatment-xray-data-dialog-ok-button">Ok</button>
      <button (click)="onCancelClick()" class="tdo-button primary-accent" style="margin-right: 6px;" data-cy="treatment-xray-data-dialog-cancel-button">Cancel</button>
    </div>
  </div>
